// Generated by ReScript, PLEASE EDIT WITH CARE

import * as React from "react";
import * as LoadingSpinnerModuleScss from "../styles/common/LoadingSpinner.module.scss";

var styles = LoadingSpinnerModuleScss;

function LoadingSpinner(Props) {
  return React.createElement("div", {
              className: styles["loading-wrapper"]
            }, React.createElement("div", {
                  className: styles["loading-ellipsis"]
                }, React.createElement("div", undefined), React.createElement("div", undefined), React.createElement("div", undefined), React.createElement("div", undefined)));
}

var make = LoadingSpinner;

export {
  styles ,
  make ,
}
/* styles Not a pure module */
